<template>
  <v-card
    :loading="$store.getters.isLoading"
    :elevation="hover ? 16 : 2"
    :class="{ 'on-hover': hover }"
    rounded="xl"
  >
    <template slot="progress">
      <v-progress-linear height="5" indeterminate style="z-index: 10" />
    </template>
    <v-card-title style="z-index: 2">
      <v-app-bar
        v-if="appBar"
        absolute
        color="gray"
        elevation="0"
        height="80"
        class="px-5"
        rounded="rounded-t-xl"
      >
        <slot name="header" />
      </v-app-bar>
      <slot v-else name="header" />
    </v-card-title>

    <v-card-text id="scrolling" class="mt-10 px-2 px-md-10">
      <v-container fluid>
        <v-row>
          <slot name="body" />
        </v-row>
      </v-container>
    </v-card-text>
    <div class="px-7">
      <v-divider></v-divider>
    </div>
    <v-card-actions v-if="action" class="py-1">
      <v-container px-5>
        <v-row
          justify="space-between"
          align-content="center"
          class="fill-height"
        >
          <slot name="actions" />
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CardModal",
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    appBar: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    const self = this;
    self.$cssEfect.htmlScroll(false);
  },
  beforeDestroy() {
    const self = this;
    self.$cssEfect.htmlScroll(true);
  },
};
</script>
